<ejs-dialog #viewerDialog [visible]="isDialogVisible" [header]="'documentViewer' | translate" [width]="'100%'" [height]="'100%'" [isModal]="true"
  [allowDragging]="false" showCloseIcon="true" cssClass="sfdv-dialog" (open)="onDialogOpen()" (close)="onDialogClose()" id="custom-dialog">

  <div *ngIf="!isDocumentViewerReady" class="viewer-info">
    <div class="viewer-loader-box">
      <div class="spinner"></div>
      <p>{{ 'components.view_temp_documents.loading_document_ultimate_viewer' | translate }}</p>
    </div>
  </div>

  <!-- Kept in the DOM while the loader shows: the iframe must exist for its
       (load) events to fire, so it is hidden rather than removed. -->
  <div *ngIf="safeDocumentUrl" class="document-viewer-container"
    [style.display]="isDocumentViewerReady ? 'flex' : 'none'">
    <iframe [src]="safeDocumentUrl" (load)="onIframeLoad()">
    </iframe>
  </div>
</ejs-dialog> 